import React, { useEffect, useState } from "react";
import { Header, Form, Grid, Button } from "semantic-ui-react";
import { useParams } from "react-router-dom";
import { renderTextField, renderOptionField } from "../formcomponents";
import { reduxForm, Field } from "redux-form";
import { userData } from "../store/userData";
import axios from "axios";
import { BaseUrlInvoice } from "../formcomponents/Constants";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
const CreateVehile = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const { id } = useParams();
  const navigate = useNavigate();
  const userDetail = userData();
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [submitDisable, setsubmitDisable] = useState(false);
  useEffect(() => {
    if (id != "null") {
      getVechileList();
    }
    if (userDetail.userRole != 1 && id != "null") {
      setbuttonDisable(true);
    }
  }, [id]);

  const getVechileList = async () => {
    await axios
      .post(BaseUrlInvoice + "accounts/listVehicle", { vehicleId: 1 })
      .then((res) => {
        const tempData = res.data.find((item) => item.vehicleId == id);
        console.log(tempData);
        initializeData(tempData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const initializeData = (data) => {
    props.initialize({
      vehicleId: data.vehicleId,
      vehicleType: data.vehicleType,
      vehicleBrand: data.vehicleBrand,
      model: data.model,
      fuelType: data.fuelType,
      currentOdoMeter: data.currentOdoMeter,
      lastDrivenBy: data.lastDrivenBy,
      lastServiceDoneOn: data.lastServiceDoneOn,
      lastServiceKms: data.lastServiceKms,
    });
  };

  const vechileType = [
    { text: "XUV", value: "XUV" },
    { text: "SEDAN", value: "SEDAN" },
    { text: "HATCHBACK", value: "HATCHBACK" },
    { text: "MINIVAN", value: "MINIVAN" },
    { text: "SUV", value: "SUV" },
    { text: "MINIVAN", value: "MINIVAN" },
  ];
  const fuelType = [
    { text: "PRTROL", value: "PETROL" },
    { text: "DIESEL", value: "DIESEL" },
    { text: "CNG", value: "CNG" },
    { text: "ELECTRIC", value: "ELECTRIC" },
  ];

  const sumbitForm = (values) => {
    //BaseUrlInvoice + "accounts
    setsubmitDisable(true);
    axios
      .post(BaseUrlInvoice + "accounts/createVehicle", values)
      .then((res) => {
        console.log(JSON.stringify(res.data, null, 2));

        // if (res.data.errCode === 200) {
        //   Swal.fire({
        //     icon: "success",
        //     title: "sccess",
        //     text: "Created",
        //   });
        //   navigate(-1);
        // }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <Header dividing size="huge" as="h1">
        {id != "null" ? "Update" : "Create"} Vehicle
      </Header>
      <br />
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            {/* <Field
                name="srNumber"
                label="SR Number"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              /> */}

            <Grid.Column>
              <Field
                name="vehicleType"
                label="Vehicle Type"
                options={vechileType}
                component={renderOptionField}
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                name="vehicleBrand"
                label="Vehicle Brand"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="model"
                label="Model"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="fuelType"
                label="Fuel Type"
                options={fuelType}
                component={renderOptionField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="currentOdoMeter"
                label="Current OdoMeter"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="lastDrivenBy"
                label="Last Driven By"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="lastServiceDoneOn"
                label="Last Service Done On"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="lastServiceKms"
                label="Last Service Kms"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              {/* <Field
                name="invoice"
                label="Invoice"
                type="text"
                component={renderTextField}
              /> */}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <br />
      <Button
        floated="right"
        positive
        disabled={submitting || buttonDisable || submitDisable}
        onClick={handleSubmit((values) =>
          sumbitForm({
            ...values,
          })
        )}
      >
        Save
      </Button>
      <Button
        floated="right"
        negative
        disabled={pristine || submitting}
        onClick={reset}
      >
        Cancel
      </Button>{" "}
    </div>
  );
};

export default reduxForm({
  form: "CreateVehile",
})(CreateVehile);
